var self = null;

class Apis {

    constructor(baseUrl, baseUrl1, imUrl) {
        self = this;
        this.baseUrl = baseUrl || "";
        this.baseUrl1 = baseUrl1 || "";
        this.imUrl = imUrl || "";
        this.fundTradeUrl = "https://sso.1234567.com.cn/FundTradeLoginState.aspx";
        this.sendHeart = this.baseUrl + "/Client/SendCustomerHeart"; // 发送心跳
        this.getClientHistoryMessagesUrl = this.baseUrl + "/Client/GetClientHistoryMessages"; //历史消息
        this.GetMessageFromRedisUrl =
        this.baseUrl + "/Client/GetMessageFromRedis"; //历史消息
        this.getClientHistoryMessagesByDeviceIdUrl = this.baseUrl + "/Client/getClientHistoryMessagesByDeviceId"; //历史消息
        this.saveMessageUrl = this.baseUrl + "/Client/SendMessage"; // 保存会话消息
        this.SendMessageWithDeviceIdUrl  = this.baseUrl + "/Client/SendMessageWithDeviceId";  // 消息入库
        this.SendMessageWithDeviceIdAndMarketUrl = this.baseUrl + '/Client/SendMessageWithDeviceIdAndMarket';  // IM 消息发送失败时调用回执
        this.endChatUrl = this.baseUrl + "/Client/EndChat"; // 结束会话
        this.getRobotChatServiceUrl = this.baseUrl + "/Client/GetRobotChatService"; //
        this.getStaffUrl = this.baseUrl + "/Client/GetStaff";
        this.applyLineupUrl = this.baseUrl + "/Client/ApplyLineup";
        this.applyLineupWithDeviceIdUrl = this.baseUrl + "/Client/ApplyLineupWithDeviceId";
        this.cancelLineupUrl = this.baseUrl + "/Client/CancelLineup";
        this.getStaffInfoUrl = this.baseUrl + "/client/JoinChannnel";    // 初次进入加入通道获取用户信息

        this.robotFeedbackUrl = this.baseUrl + "/client/FeedBack"; // 反馈接口
        this.beforeChatUrl = this.baseUrl + "/client/SendMessageToRobot"; // 接入人工前发送消息
        this.enterChatReSendMessageUrl = this.baseUrl + "/client/ReSendMessage"; // 进入人工之后重新发送消息
        this.robotRefreshTimeUrl = this.baseUrl + '/client/RefreshTime?customerID=';

        // 机器人相关接口
        this.getPresetQuestionsUrl = this.baseUrl1 + "/Question/GetPresetQuestions"; // 初次进入获得机器人推送的热门问题
        this.getSimilarQuestionUrl1 = this.baseUrl1 + "/Question/GetTypeAssist"; // 模糊查询
        this.askRobotUrl = this.baseUrl1 + "/Robot/Ask";

        // im相关接口
        this.imageServiceUrl = this.imUrl + window.configs['imageServiceUrl'] || 　'/ImageService';
        
        this.anonymousUserUrl = this.baseUrl + "/Client/AnonymousUser";
        // 大数据反馈接口
        this.qaUserOptUrl = configs.baseDir + window.configs["bigDataFeedback"] || ""
    }

    /**
     * 匿名登陆
     * @param {Object} params
     */
    anonymousUser(params) {
		return superagent.post(this.anonymousUserUrl, params)
			.then(res => {
				if (res.status === 200) {
					return res.body;
				} else {
					throw res.body;
				}
			});
    }
    
    // 大数据接口无论请求是否成功，不做处理
    qaUserOpt(params) {
        return superagent.post(this.qaUserOptUrl).send(params);
    }

    /**
     * 退出或关闭时调用
     * @param {String} customerId
     */
    endChat(customerId) {
        return superagent.post(this.endChatUrl)
            .send({ customerId: customerId })
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.bosy;
                }
            })
    }

    // 机器人维持channel
    robotRefreshTime(customerId) {
        return superagent.get(this.robotRefreshTimeUrl + window.encodeURIComponent(`${customerId}`) + '&_t=' + new Date().getTime())
            .send()
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 保存消息(不含设备id)
     */
    saveMessage(params) {
        return superagent.post(this.saveMessageUrl, params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 保存消息(含设备id)
     */
    sendMessageWithDeviceId(params) {
        return superagent.post(this.SendMessageWithDeviceIdUrl)
            .send(params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * IM 消息发送失败时调用
     */
    SendMessageWithDeviceIdAndMarket(params) {
      return superagent.post(this.SendMessageWithDeviceIdAndMarketUrl)
      .send(params)
      .then(res => {
        if (res.status === 200) {
          return res.body;
        } else {
          throw res.body;
        }
      })
    }

    /**
     * 模糊查询
     */
    getSimilarQuestion1(params) {
        return superagent.post(this.getSimilarQuestionUrl1)
            .send(params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
	 * 加入频道
	 */
	getStaffInfo(params) {
        return superagent
        .post(this.getStaffInfoUrl)
        .send(params)
        .set('accept', 'json')
        .then(res => {
          if (res.status === 200) {
              return res.body;
          } else {
              throw res.body;
          }
      })
    }
    
    
    /**
     * 拉取场景推送问题
     */
    getPresetQuestions(params) {
      return superagent
        .post(this.getPresetQuestionsUrl)
        .send(params)
        .set('accept', 'json')
        .then(res => {
          if (res.status === 200) {
              return res.body;
          } else {
              throw res.body;
          }
      })
    }

    /**
     * 发送问题给机器人
     */
    askRobot(params) {
      return superagent
        .post(this.askRobotUrl)
        .send(params)
        .set('accept', 'json')
        .then(res => {
          if (res.status === 200) {
              return res.body;
          } else {
              throw res.body;
          }
      })
    }

    /**
     * 发送心跳包
     * @param {String} customerid 用户id  funchatId
     */
    sendCustomerHeart(customerid) {
        return superagent.post(this.sendHeart)
            .send({ customerid: customerid })
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 取消排队
     */
    cancelLineup(customerid) {
        return superagent.post(this.cancelLineupUrl)
            .send({ customerid: customerid })
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 获取客户端历史记录
     */
    getClientHistoryMessages(params) {
        return superagent.post(this.getClientHistoryMessagesUrl)
            .send(params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 获取客户端历史记录
     */
    getClientHistoryMessagesByDeviceId(params) {
        return superagent
        .post(this.getClientHistoryMessagesByDeviceIdUrl)
        .send(params)
        .set('accept', 'json')
        .then(res => {
          if (res.status === 200) {
              return res.body;
          } else {
              throw res.body;
          }
        })
    }

     /**
     * 获取客户端历史记录redis
     */
    GetMessageFromRedis(params) {
        return superagent
        .get(this.GetMessageFromRedisUrl, params)
        .then(res => {
            if (res.status === 200) {
            return res.body;
            } else {
            throw res.body;
            }
        });
    }

    /**
     * 转人工接口
     */
    applyLineup(params) {
      return superagent
        .post(this.applyLineupUrl)
        .send(params)
        .set('accept', 'json')
        .then(res => {
          if (res.status === 200) {
              return res.body;
          } else {
              throw res.body;
          }
      })
    }

    applyLineupWithDeviceId(params) {
        return superagent.post(this.applyLineupWithDeviceIdUrl)
            .send(params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 获取客服状态
     * @param {String} customerid customerid 用户id  funchatId
     */
    getStaff(customerid) {
        return superagent.post(this.getStaffUrl)
            .send({ customerid: customerid })
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 获取登陆信息
     * @param {Functoin} cb 回调函数
     */
    fundTrade(cb) {
        this.loadScript(this.fundTradeUrl, function() {
            cb && cb(customer);
        });
    }
    fundTradeInfo() {
        return superagent.get(this.fundTradeUrl)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

    /**
     * 获得初始状态
     * @param {*} params
     */
    getRobotChatService(params) {
        return superagent.post(this.getRobotChatServiceUrl)
            .send(params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
    }

	/**
	 * 反馈
	 */
    feedback(params) {
        return superagent.post(this.robotFeedbackUrl)
            .send(params)
            .then(res => {
                if (res.status === 200) {
                    return res.body;
                } else {
                    throw res.body;
                }
            })
      }
    
      /**
       * 进入人工聊天之前发送消息
       */
      beforeChat(params) {
        return superagent.post(this.beforeChatUrl)
        .send(params)
        .then(res => {
            if (res.status === 200) {
                return res.body;
            } else {
                throw res.body;
            }
        })
      }
      /**
      * 进入人工聊天之前发送消息
      */
      enterChatReSendMessage(params) {
        return superagent.post(this.enterChatReSendMessageUrl)
        .send(params)
        .then(res => {
            if (res.status === 200) {
                return res.body;
            } else {
                throw res.body;
            }
        })
      }

    /**
     * 文件下载
     */
    downLoadFile(url, headers) {
        return superagent.get(url)
            .set(headers)
            .responseType('blob')
            .then(res => {
                var link = null;
                try {
                    return window.URL.createObjectURL(res.body)
                } catch (err) {
                    throw ''
                }
            })
    }

    loadScript(url, cb) {
        var script = document.createElement("script");
        script.setAttribute("src", url);

        script.onload = function() {
            script.onload = null;
            script.parentNode.removeChild(script),
                cb && cb()
        }

        document.getElementsByTagName("head")[0].appendChild(script);
    }
}

export default new Apis(window.configs.baseUrl, window.configs.baseUrl1, window.configs.imUrl);



// WEBPACK FOOTER //
// ./src/store/apis.js